import React from 'react';
import ContentLoader from 'react-content-loader';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { times } from 'lodash';

import { useStyles } from './RowLoading.useStyles';

export interface RowLoadingProps extends WithStyles<typeof useStyles> {
  colSpan: number;
}

const RowLoading: React.FC<RowLoadingProps> = ({ classes, colSpan }) => (
  <>
    {times(3).map((idx) => (
      <tr key={idx} className={classes.root}>
        <td colSpan={colSpan}>
          <div className={classes.wrapper}>
            <ContentLoader key={idx} height={20} width={600} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
              <rect x="24" y="8" rx="3" ry="3" width="243" height="6" />
            </ContentLoader>
          </div>
        </td>
      </tr>
    ))}
  </>
);

export default withStyles(useStyles)(RowLoading);
